import get from 'lodash/get';
import {
	GET_REASON_SUCCESS,
	CLEAR_RETURN_SUMMARY,
	GET_ACTIONS_SUCCESS,
	SAVE_RETURN_IMAGE_SUCCESS
} from 'fk-cp-common-components/actions/returnActions';
import { GET_RETURN_ADDRESSLIST_SUCCESS } from 'actions/SelfServeActions/returnAddressActions';
import { UPLOAD_IMAGE_SUCCESS } from 'actions/SelfServeActions/imageUploadActions';

const INITIAL_STATE = {
	reasonToken: null,
	addressToken: null,
	actionsToken: null
};

export default (state = INITIAL_STATE, action = {}) => {
	switch (action.type) {
		case GET_REASON_SUCCESS:
			return Object.assign({}, state, {
				reasonToken: get(action.data, ['token']),
				lastResponseToken: get(action.data, ['token'])
			});
		case GET_RETURN_ADDRESSLIST_SUCCESS:
			return Object.assign({}, state, {
				addressToken: get(action.data, ['token']),
				lastResponseToken: get(action.data, ['token'])
			});
		case GET_ACTIONS_SUCCESS:
			return Object.assign({}, state, {
				actionsToken: get(action.data, ['token']),
				lastResponseToken: get(action.data, ['token'])
			});
		case UPLOAD_IMAGE_SUCCESS:
		case SAVE_RETURN_IMAGE_SUCCESS:
			return Object.assign({}, state, {
				imageToken: get(action.data, ['token']),
				lastResponseToken: get(action.data, ['token'])
			});
		case CLEAR_RETURN_SUMMARY:
			return INITIAL_STATE;
		default:
			return state;
	}
};
